import axios from 'axios'

function emptyPodft () {
  return { success: true, message: '', setDocument: false }
}

export function ensureClientVerifyState (client) {
  if (!client || typeof client !== 'object') {
    return client
  }
  if (!Object.prototype.hasOwnProperty.call(client, 'beingVerify')) {
    client.beingVerify = false
  }
  if (!client.podft || typeof client.podft !== 'object') {
    client.podft = emptyPodft()
  }
  return client
}

export function useBpmClientVerify ({ notify }) {
  function verifyClient (client) {
    const target = ensureClientVerifyState(client)
    if (!target || target.beingVerify) {
      return Promise.resolve()
    }

    target.beingVerify = true
    target.podft = emptyPodft()

    return axios
      .post('/api/v2/customer/bpm/verify', target)
      .then(res => {
        const data = res.data || {}
        target.podft = {
          success: data.success !== false,
          message: data.message || '',
          code: data.code || 0,
          setDocument: !!data.setDocument,
        }
        if (!target.podft.success) {
          notify.error({ message: 'Клиент: ' + target.client.title + ', ИИН: ' + target.client.iin + '. ' + target.podft.message || 'Проверка клиента не пройдена' })
        }
      })
      .catch(err => {
        target.podft = {
          success: false,
          message: 'Ошибка при проверке клиента. Попробуйте снова.',
          code: 0,
          setDocument: false,
        }
        notify.error(err)
      })
      .finally(() => {
        target.beingVerify = false
      })
  }

  return {
    verifyClient,
    ensureClientVerifyState,
  }
}
